import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import HomeBanner from "./HomeBanner";
import useLocale from "../locales";
import sipIcon from "../assets/svg/sip.svg";
import rightArrow from "../assets/svg/right-arrow.svg";
import personalIcon from "../assets/svg/personal.svg";
import fixedIcon from "../assets/svg/fixed.svg";
import rdIcon from "../assets/svg/rd.svg";
import networthIcon from "../assets/svg/networth.svg";
import earlyIcon from "../assets/svg/early-loan.svg";
import educationIcon from "../assets/svg/education-loan.svg";
import creditIcon from "../assets/svg/credit-pay.svg";
import mortgageIcon from "../assets/svg/mortgage.svg";
import bussinessIcon from "../assets/svg/bussiness.svg";
import gstIcon from "../assets/svg/gst.svg";
import pensionIcon from "../assets/svg/pension.svg";
import propertyIcon from "../assets/svg/property.svg";
import salaryIcon from "../assets/svg/hourly.svg";
import carIcon from "../assets/svg/car-lease.svg";
import contrubutionIcon from "../assets/svg/contribution.svg";
import savingIcon from "../assets/svg/saving-goal.svg";
import dtiIcon from "../assets/svg/dti.svg";
import { useDispatch } from "react-redux";
import { setActiveCalculator } from "../redux/calculations/calculaterSlice";
import { Helmet } from "react-helmet";
import GoalPLanner, { GoalPlannerCard } from "./GoalPLanner";

const MainCards = () => {
  const { textData } = useLocale();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [goalPlannerOpen, setGoalPlannerOpen] = React.useState(false);
  const iconComponents = {
    sip: sipIcon,
    personal: personalIcon,
    fixed: fixedIcon,
    rd: rdIcon,
    dti: dtiIcon,
    networth: networthIcon,
    "early-loan": earlyIcon,
    "education-loan": educationIcon,
    "credit-pay": creditIcon,
    bussiness: bussinessIcon,
    property: propertyIcon,
    "car-lease": carIcon,
    "saving-goal": savingIcon,
    contribution: contrubutionIcon,
    hourly: salaryIcon,
    mortgage: mortgageIcon,
    gst: gstIcon,
    pension: pensionIcon,
  };

  const cardData = [
    {
      id: "sipCalc",
      icon: "sip",
      alt: "sip swp calculator",
      titleKey: "filterDropDown.sipCalc",
      descriptionKey: "cardsLabel.sipDesciption",
      bgColor: "light-green",
      borderColor: "dark-green",
      path: "/calculator/sip-investment-calculator",
    },
    {
      id: "personalLoanCalc",
      icon: "personal",
      alt: "personal loan calculator",
      titleKey: "filterDropDown.personalLoanCalc",
      descriptionKey: "personalTital",
      bgColor: "light-sky",
      borderColor: "sky-blue",
      path: "/calculator/personal-loan-calculator",
    },
    {
      id: "FDCalc",
      icon: "fixed",
      alt: "fixed deposit calculator",
      titleKey: "filterDropDown.FDCalc",
      descriptionKey: "descriptionfd",
      bgColor: "light-green",
      borderColor: "dark-green",
      path: "/calculator/fixed-deposit-calculator",
    },
    {
      id: "RDCalc",
      icon: "rd",
      alt: "recurring deposit calculator",
      titleKey: "filterDropDown.RDCalc",
      descriptionKey: "cardsLabel.sipDesciption",
      bgColor: "light-sky",
      borderColor: "sky-blue",
      path: "/calculator/recurring-deposit-calculator",
    },
    {
      id: "DTICalc",
      icon: "dti",
      alt: "debt to income ratio calculator",
      titleKey: "filterDropDown.DTICalc",
      descriptionKey: "dtiCalc.descriptionText",
      bgColor: "light-green",
      borderColor: "dark-green",
      path: "/calculator/debt-to-income-ratio-calculator",
    },
    {
      id: "netWorthCalc",
      icon: "networth",
      alt: "net worth calculator",
      titleKey: "filterDropDown.netWorthCalc",
      descriptionKey: "netWorthCalc.description",
      bgColor: "light-sky",
      borderColor: "sky-blue",
      path: "/calculator/net-worth-calculator",
    },

    {
      id: "earlyLoanCalc",
      icon: "early-loan",
      alt: "early loan payoff calculator",
      titleKey: "filterDropDown.earlyLoanCalc",
      descriptionKey: "earlyPayoffCalc.description",
      bgColor: "light-green",
      borderColor: "dark-green",
      path: "/calculator/loan-payoff-calculator",
    },
    {
      id: "educationLoanCalc",
      icon: "education-loan",
      alt: "education loan calculator",
      titleKey: "filterDropDown.educationLoanCalc",
      descriptionKey: "educationCalc.educationdiscription",
      bgColor: "light-sky",
      borderColor: "sky-blue",
      path: "/calculator/student-education-loan-calculator",
    },
    {
      id: "creditCardPayoffCalc",
      icon: "credit-pay",
      alt: "credit card payoff calculator",
      titleKey: "filterDropDown.creditCardPayoffCalc",
      descriptionKey: "creditCalc.description",
      bgColor: "light-green",
      borderColor: "dark-green",
      path: "/calculator/credit-card-payoff-calculator",
    },
    {
      id: "businessLoanCalc",
      icon: "bussiness",
      alt: "business loan calculator",
      titleKey: "filterDropDown.businessLoanCalc",
      descriptionKey: "bussinesCal.description",
      bgColor: "light-sky",
      borderColor: "sky-blue",
      path: "/calculator/business-loan-calculator",
    },
    {
      id: "GSTCalc",
      icon: "gst",
      alt: "gst vat calculator",
      titleKey: "filterDropDown.GSTCalc",
      descriptionKey: "vatCalc.description",
      bgColor: "light-green",
      borderColor: "dark-green",
      path: "/calculator/gst-tax-calculator",
    },
    {
      id: "salaryCalc",
      icon: "hourly",
      alt: "hourly to salary calculator",
      titleKey: "filterDropDown.salaryCalc",
      descriptionKey: "annualSalaryCalc.description",
      bgColor: "light-sky",
      borderColor: "sky-blue",
      path: "/calculator/salary-calculator",
    },
    {
      id: "pensionCalc",
      icon: "pension",
      alt: "pension calculator",
      titleKey: "filterDropDown.pensionCalc",
      descriptionKey: "pensionCalc.description",
      bgColor: "light-green",
      borderColor: "dark-green",
      path: "/calculator/pension-calculator",
    },
    {
      id: "carCalc",
      icon: "car-lease",
      alt: "car lease vs buy calculator",
      titleKey: "filterDropDown.carCalc",
      descriptionKey: "carCalc.description",
      bgColor: "light-sky",
      borderColor: "sky-blue",
      path: "/calculator/car-lease-calculator",
    },
    {
      id: "mortgageCalc",
      icon: "mortgage",
      alt: "mortgage refinancing calculator",
      titleKey: "filterDropDown.mortgageCalc",
      descriptionKey: "mortgageCalc.description",
      bgColor: "light-green",
      borderColor: "dark-green",
      path: "/calculator/mortgage-loan-refinance-calculator",
    },
    {
      id: "contributionCalc",
      icon: "contribution",
      alt: "401k contribution calculator",
      titleKey: "filterDropDown.contributionCalc",
      descriptionKey: "retirementDescription",
      bgColor: "light-sky",
      borderColor: "sky-blue",
      path: "/calculator/401k-retirement-calculator",
    },
    {
      id: "savingCalc",
      icon: "saving-goal",
      alt: "savings goal calculator",
      titleKey: "filterDropDown.savingCalc",
      descriptionKey: "savingCalc.description",
      bgColor: "light-green",
      borderColor: "dark-green",

      path: "/calculator/saving-goal-calculator",
    },
    {
      id: "loanToValueCalc",
      icon: "fixed",
      alt: "loan to value ratio calculator",
      titleKey: "filterDropDown.loanToValueCalc",
      descriptionKey: "ltvCalc.description",
      bgColor: "light-sky",
      borderColor: "sky-blue",
      path: "/calculator/loan-to-value-calculator",
    },
  ];
  const handleCardClick = (calculatorId, path, titleKey) => {
    navigate(path, { state: { titleKey } });
  };

  const getNestedValue = (obj, path) => {
    return path.split(".").reduce((o, p) => o?.[p], obj);
  };
  useEffect(() => {
    dispatch(setActiveCalculator(""));
  }, ["activeCalculator"]);

  const bgClassMap = {
    "light-green": "bg-light-green",
    "light-sky": "bg-light-sky",
  };

  const borderClassMap = {
    "dark-green": "border-dark-green",
    "sky-blue": "border-sky-blue",
  };

  return (
    <>
      <Helmet>
        <title>Expert-Backed Free Online Finance Calculators | GrowLifeFund</title>
        <meta
          name="description"
          content="Use GrowLifeFund Free Online Finance Calculators to plan smarter, compare options, and make data-driven, expert-backed financial decisions with confidence."
        />
        <link rel="canonical" href="https://growlifefund.com/" />
        <meta name="robots" content="index, follow" />

        <meta
          property="og:title"
          content="Expert-Backed Free Online Finance Calculators | GrowLifeFund"
        />
        <meta
          property="og:description"
          content="Use GrowLifeFund Free Online Finance Calculators to plan smarter, compare options, and make data-driven, expert-backed financial decisions with confidence."
        />
        <meta property="og:url" content="https://growlifefund.com/" />
        <meta property="og:site_name" content="growlifefund" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en" />
        <meta
          property="og:image:alt"
          content="Expert backed Free Online Finance Calculators"
        />

        <link rel="apple-touch-icon" href="/GrowLogo_180x180.png" />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/GrowLogo_180x180.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="152x152"
          href="/GrowLogo_152x152.png"
        />
      </Helmet>
      <HomeBanner />

      <div className=" max-w-[1280px] md:mx-[80px] mx-4 sm:mx-10 lg:mx-[50px] xl:mx-[120px] 2xl:mx-auto">
        {/* Goal Planner Card - Above Calculators */}
        <div className="px-4 sm:px-0 pt-6">
          <GoalPlannerCard onOpen={() => setGoalPlannerOpen(true)} />
        </div>

        <h2 className="text-black font-lato-bold-700 text-lg sm:text-[20px] md:text-[22px] text-center mt-[27px] mb-10">
          {textData.ourTitle}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md882:grid-cols-2  md:grid-cols-2 lg:grid-cols-3 lg110:grid-cols-4 xl:grid-cols-4 gap-x-5 gap-y-4 sm:gap-x-5  xl:gap-x-[24px] xl:gap-y-5 px-4 sm:px-0 ">
          {cardData.map((card) => (
            <div
              key={card.id}
              onClick={() => handleCardClick(card.id, card.path, card.titleKey)}
              className={`${bgClassMap[card.bgColor]} ${borderClassMap[card.borderColor]
                } border border-solid  rounded-xl px-[20px] py-[38px] hover:shadow-md transition-shadow duration-300 relative cursor-pointer`}
            >
              <div className="flex flex-col gap-[12px]">
                <img
                  src={iconComponents[card.icon]}
                  alt={card.alt}
                  className="w-[42px] h-[40px]"
                  aria-hidden="true"
                />
                <div className="flex flex-col gap-[24px]">
                  <div className="flex flex-col gap-[12px]">
                    <h3 className="font-lato-semibold-600 text-[16px] xl:text-[16px] text-black">
                      {getNestedValue(textData, card.titleKey)}
                    </h3>
                    <p className="font-lato-regular-400 text-[14px] text-gray-font">
                      {getNestedValue(textData, card.descriptionKey)}
                    </p>
                  </div>
                  <div className="flex gap-2 sm:gap-3 items-center">
                    <span className="text-sm sm:text-base font-lato-semibold-600 text-primary">
                      {textData.cardsLabel.calculateNow}
                    </span>
                    <img
                      src={rightArrow}
                      alt="Right Arrow"
                      className="w-4 h-4"
                      aria-hidden="true"
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <GoalPLanner isOpen={goalPlannerOpen} onClose={() => setGoalPlannerOpen(false)} />
    </>
  );
};

export default MainCards;
